import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useLanguage } from '../../context/LanguageContext';

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const location = useLocation();
  const { user } = useAuth();
  const { t } = useLanguage();

  const menuItems = [
    { path: '/', label: t('nav.dashboard'), icon: '📊' },
    { path: '/equipment', label: t('nav.equipment'), icon: '🔧' },
    { path: '/orders', label: t('nav.orders'), icon: '🛒' },
    { path: '/parts', label: t('nav.parts'), icon: '⚙️' },
    { path: '/stock-movements', label: t('nav.stockMovements'), icon: '📈' },
    { path: '/equipment-templates', label: t('nav.templates'), icon: '📋' },
    { path: '/component-stock', label: t('nav.componentStock'), icon: '🧩' },
    { path: '/production-tasks', label: t('nav.productionTasks'), icon: '📝' },
    { path: '/repairs', label: t('nav.repairs'), icon: '🩹' },
    { path: '/customers', label: t('nav.customers'), icon: '🧑' },
    { path: '/dealers', label: t('nav.dealers'), icon: '🏬' },
    { path: '/devices', label: t('nav.devices'), icon: '🔩' },
    ...(user?.userType === 'admin'
      ? [{ path: '/users', label: t('nav.users'), icon: '👤' }]
      : []),
    { path: '/vacations', label: t('nav.vacations'), icon: '🏖️' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {isOpen && (
        <div
          className='fixed inset-0 bg-black bg-opacity-50 z-20 lg:hidden'
          onClick={toggleSidebar}
        />
      )}

      <aside
        className={`fixed lg:static inset-y-0 left-0 z-30 w-64 bg-white shadow-lg transform transition-transform duration-300 ease-in-out ${
          isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'
        }`}
      >
        <div className='h-full overflow-y-auto py-6'>
          <nav className='space-y-1 px-3'>
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => window.innerWidth < 1024 && toggleSidebar()}
                className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors duration-200 ${
                  isActive(item.path)
                    ? 'bg-[#F0F0F0] text-[#361826]'
                    : 'text-[#787878] hover:bg-gray-100'
                }`}
              >
                <span className='text-xl'>{item.icon}</span>
                <span className='font-medium'>{item.label}</span>
              </Link>
            ))}
          </nav>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
